import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import OrderCancelManagementContainer from '../../containers/order/OrderCancelManagementContainer';
import { ORDER_PAGE_NAME } from '../../constants/service/app/orderConstants';

const OrderDetail = () => {
  return (
    <PageTemplate pageName={ORDER_PAGE_NAME.ORDER_CANCEL_MANAGEMENT}>
      <OrderCancelManagementContainer />
    </PageTemplate>
  );
};

export default OrderDetail;
